'use client';

import React, { memo } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Icons,
} from '@shared/ui';
import getHTML from '@shared/get-html';
import type { ContentPropTypes } from './StandardContent';
import STYLE from './ProductDescription.module.scss';
import { allowedTags } from './config';

interface AccordionPropTypes extends ContentPropTypes {}

const _AccordionContent: React.FC<AccordionPropTypes> = (props) => {
    const { title, description } = props;

    return (
        <Accordion defaultIndex={[0]} allowMultiple>
            <AccordionItem>
                {({ isExpanded }) => (
                    <>
                        <AccordionButton className={STYLE.productDescriptionTitle}>
                            <span className={STYLE.accordionTitle}>{title}</span>
                            {isExpanded ? <Icons.csr.Minus /> : <Icons.csr.Plus />}
                        </AccordionButton>
                        <AccordionPanel>
                            {getHTML(
                                description,
                                'div',
                                {
                                    className: STYLE.productDescriptionContent,
                                },
                                {
                                    domPurifyConfig: {
                                        ALLOWED_TAGS: allowedTags,
                                    },
                                }
                            )}
                        </AccordionPanel>
                    </>
                )}
            </AccordionItem>
        </Accordion>
    );
};

export const AccordionContent = memo(_AccordionContent);
